import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Updates the stock availability block when another variant is selected.
 */
class MxStockAvailability extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    this.#section = null;
  }

  /** @param {Event} event */
  #handleVariantUpdate = (event) => {
    const { data } = /** @type {CustomEvent} */ (event).detail;

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const next = data.html.querySelector(`mx-stock-availability[data-block-id="${this.dataset.blockId}"]`);
    if (!(next instanceof HTMLElement)) return;

    this.hidden = next.hidden;
    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('mx-stock-availability')) {
  customElements.define('mx-stock-availability', MxStockAvailability);
}
